export default __webpack_public_path__ + "static/media/up-down-color.b5628a1d.svg";